var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSanMarino(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0001C32 24.8366 24.8365 32.0001 16 32.0001C7.1635 32.0001 0 24.8366 0 16.0001C0.695625 16.0001 16 13.9131 16 13.9131L32 16.0001Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3506 11.0402L15.9995 17.3913L9.64854 11.0402C8.82723 12.2594 8.34741 13.7268 8.34741 15.3043V17.3912C8.34741 20.7422 10.5127 23.5968 13.5175 24.63C13.1165 25.416 13.1841 26.3969 13.7718 27.1303C14.5523 26.5048 15.3604 25.8572 16.0459 25.308C16.7314 25.8573 17.5395 26.5048 18.3199 27.1303C18.9145 26.3883 18.9772 25.3927 18.5604 24.6021C21.5241 23.5465 23.6517 20.7128 23.6517 17.3912V15.3043C23.6517 13.7268 23.1719 12.2595 22.3506 11.0402V11.0402Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.9564C12.9313 22.9564 10.4348 20.4598 10.4348 17.3912V15.3042C10.4348 12.2355 12.9314 9.73904 16 9.73904C19.0686 9.73904 21.5652 12.2356 21.5652 15.3042V17.3912C21.5652 20.4598 19.0687 22.9564 16 22.9564Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4785 17.3916V15.3046C19.4785 13.3867 17.9181 11.8264 16.0002 11.8264C14.0823 11.8264 12.522 13.3867 12.522 15.3046V17.3916L16.0002 18.0872L19.4785 17.3916Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.522 17.3915C12.522 19.3095 14.0823 20.8698 16.0002 20.8698C17.9181 20.8698 19.4785 19.3094 19.4785 17.3915H12.522Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1732 9.73904C20.1732 8.58648 19.2389 7.6521 18.0863 7.6521C17.5516 7.6521 17.0643 7.85335 16.695 8.18392V6.95642H17.3906V5.5651H16.695V4.86948H15.3037V5.5651H14.6081V6.95642H15.3037V8.18392C14.9344 7.85335 14.447 7.6521 13.9124 7.6521C12.7598 7.6521 11.8254 8.58648 11.8254 9.73904C11.8254 10.357 12.0943 10.912 12.5211 11.2942V12.5217H19.4776V11.2942C19.9044 10.912 20.1732 10.357 20.1732 9.73904V9.73904Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanMarino);
export default __webpack_public_path__ + "static/media/san-marino.611f5f69.svg";
export { ForwardRef as ReactComponent };